import { render, staticRenderFns } from "./ToastAlert.vue?vue&type=template&id=3820ae25&scoped=true"
import script from "./ToastAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastAlert.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToastAlert.vue?vue&type=style&index=0&id=3820ae25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820ae25",
  null
  
)

export default component.exports